import { IVenue } from "../redux/types/event";

/*
* Получение уникального id места (venue)
* для place используем place._id
* для location используем координаты, т.к. у location нету _id
*/
export const getVenueId = (venue: IVenue):string => {
  switch (venue.type) {
    case "place": {
      return `${venue.place._id}`;
    }
    case "location": {
      return `location_${venue.location.mapPosition.coordinates[0]}_${venue.location.mapPosition.coordinates[1]}`;
    }
    default: {
      throw new Error(`Can't get venueId for this venue ${venue}`);
    }
  }
};
